<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">管理账号</span></div>
		<div class="margin-top margin-left margin-right">
			<div style="display: flex;">
				<input type="text" v-model="name" placeholder="输入姓名/昵称/手机号搜索" style="width: 240px;"
					   @keyup.enter="doSearch"/>
				<Button color="primary" :loading="loading" @click="doSearch">搜索</Button>
				<Button color="primary" style="margin-left: auto;" icon="fa fa-plus" @click="openForm()">添加管理员</Button>
			</div>
		</div>
		<div class="h-panel-body">
			<Table :datas="dataList" :loading="loading">
				<TableItem prop="id" title="ID" :width="70"/>
				<TableItem prop="mobile" title="登录账号" :width="140"/>
				<TableItem prop="nickname" title="昵称"/>
				<TableItem prop="realName" title="姓名"/>
				<TableItem title="最后登录时间" :width="160">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.lastLoginDate) }}
					</template>
				</TableItem>
				<TableItem title="创建时间" :width="160">
					<template slot-scope="{data}">
						{{ datetimeFormat(data.createDate) }}
					</template>
				</TableItem>
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="openReset(data)">重置密码</span>
						<span @click="remove(data)">移除</span>
					</div>
				</TableItem>
			</Table>
			<Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
						@change="loadList" small align="right"/>
		</div>

		<Modal v-model="showForm" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">添加管理员</div>
			<Form :labelWidth="90" ref="form" :rules="validationRules" :model="form">
				<FormItem label="登录账号" prop="mobile">
					<input type="text" v-model="form.mobile" maxlength="32" placeholder="手机号或账号"/>
				</FormItem>
				<FormItem label="登录密码" prop="password">
					<input type="password" v-model="form.password" maxlength="32" placeholder="留空则不修改已有账号密码"/>
				</FormItem>
				<FormItem label="昵称" prop="nickname">
					<input type="text" v-model="form.nickname" maxlength="32" placeholder="例如：运营管理员"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showForm=false">取消</Button>
				<Button color="primary" :loading="saving" @click="save">保存</Button>
			</div>
		</Modal>

		<Modal v-model="showReset" hasCloseIcon hasDivider :closeOnMask="false">
			<div slot="header">重置密码 - {{ current.nickname || current.mobile }}</div>
			<Form :labelWidth="90" ref="resetForm" :rules="resetRules" :model="resetForm">
				<FormItem label="新密码" prop="password">
					<input type="password" v-model="resetForm.password" maxlength="32" placeholder="请输入新密码"/>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="showReset=false">取消</Button>
				<Button color="primary" :loading="saving" @click="resetPassword">保存</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>
	import moment from 'moment';

	export default {
		name: "AdminAccounts",
		data() {
			return {
				loading: false,
				saving: false,
				showForm: false,
				showReset: false,
				name: '',
				dataList: [],
				current: {},
				pagination: {page: 1, size: 20, total: 0},
				form: {},
				resetForm: {},
				validationRules: {
					required: ['mobile']
				},
				resetRules: {
					required: ['password']
				}
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				this.$api.admin.adminAccounts({
					page: this.pagination.page,
					size: this.pagination.size,
					name: this.name || undefined
				}).then(({data}) => {
					this.dataList = data.records || [];
					this.pagination.total = Number(data.total || 0);
				}).finally(() => this.loading = false);
			},
			doSearch() {
				this.pagination.page = 1;
				this.loadList();
			},
			openForm() {
				this.form = {mobile: '', password: '', nickname: ''};
				this.showForm = true;
			},
			save() {
				if (!this.$refs.form.valid().result) {
					return;
				}
				this.saving = true;
				this.$api.admin.addAdminAccount(this.form).then(() => {
					this.$Message.success('保存成功~');
					this.showForm = false;
					this.loadList();
				}).finally(() => this.saving = false);
			},
			openReset(data) {
				this.current = data;
				this.resetForm = {password: ''};
				this.showReset = true;
			},
			resetPassword() {
				if (!this.$refs.resetForm.valid().result) {
					return;
				}
				this.saving = true;
				this.$api.admin.updateAdminAccount({id: this.current.id, password: this.resetForm.password}).then(() => {
					this.$Message.success('密码已重置~');
					this.showReset = false;
				}).finally(() => this.saving = false);
			},
			remove(data) {
				this.$Confirm(`移除后【${data.nickname || data.mobile}】将失去管理后台权限，确认移除?`).then(() => {
					this.$api.admin.deleteAdminAccount({id: data.id}).then(() => {
						this.$Message.success('移除成功~');
						this.loadList();
					});
				});
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>
